import programs from '../../database/programs.json'
import organizations from '../../database/organizations.json'

const data = {
  '/search-results/program': programs,
  '/search-results/organization': organizations,
  '/search-results/event': [
    {
      image: '/images/events/khub_missing.jpg',
      date: '25 Mar - 12 May',
      organization: 'Peacegen Indonesia',
      title: 'MISSING: Konser 10 Tahun Kamisan dalam Pusaran Negeri',
    },
    {
      image: '/images/events/khub_missing.jpg',
      date: '8 Aug',
      organization: 'Peacegen Indonesia',
      title: 'Indonesia Millennial Summit 2020',
    },
    {
      image: '/images/events/khub_missing.jpg',
      date: '25 Mar',
      organization: 'Peacegen Indonesia',
      title: 'Indonesia Millennial Summit 2020',
    },
    {
      image: '/images/events/khub_missing.jpg',
      date: '25 Mar',
      organization: 'Peacegen Indonesia',
      title: 'Indonesia Millennial Summit 2020',
    },
  ],
  '/search-results/resources': [],
  '/search-results/blog': [
    {
      image: '/images/blog/khub_blog_4.jpg',
      thumbnail: '/images/blog/khub_blog_4.jpg',
      category: 'News',
      organization: 'Peacegen Indonesia',
      title: 'Indonesia Millennial Summit 2020',
    },
    {
      image: '/images/blog/khub_blog_4.jpg',
      thumbnail: '/images/blog/khub_blog_4.jpg',
      category: 'News',
      organization: 'Peacegen Indonesia',
      title: 'Indonesia Millennial Summit 2020',
    }
  ]
}

export default data
